import { Injectable } from '@angular/core';
import { DashboardResponse, UserSessionService } from '@com-delta-idp/mnx-oauth';
import { CookieHelperService } from '@com-delta-idp/mnx-utils';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DataLayerAnalytics, User } from '../../models/analytics/analytics.interface';
import { DataLayerPageLoad, NonLoggedInUser } from '../../models/analytics/data-layer.constants';
import { getLoggedInStatus, getPageInfoDataForAnalytics, getUserDataForAnalytics } from '../../utils/analytics.utils';

@Injectable({ providedIn: 'root' })
export class DataLayerAnalyticsService {
  analyticsData: DataLayerAnalytics = DataLayerPageLoad;
  user: User = NonLoggedInUser;
  pageLoadStart!: number;
  protected unsubscribe: Subject<void> = new Subject();



  constructor (
    private cookieService: CookieHelperService,
    private userSessionService: UserSessionService
  ) {
    if (getLoggedInStatus()) {
      this.userSessionService
      .getUserSession()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
          (response :DashboardResponse ) => {
            if (response) {
              this.user = getUserDataForAnalytics(
                this.analyticsData,
                response
              );
              this.setUserDataForAnalytics();
              this.setAdobeAnalytics(this.analyticsData);
            } else {
              this.setAdobeAnalytics(this.analyticsData);
            }
          },
          () => {
            this.setAdobeAnalytics(this.analyticsData);
          }
        );
    }

  }

  setUserDataForAnalytics(): void {
    this.analyticsData = {
      ...this.analyticsData,
      user: this.user
    };
  }

  setAdobeAnalytics(data: DataLayerAnalytics) {
    window.adobeDataLayer = window.adobeDataLayer || [];
    window.adobeDataLayer.push(data);
  }

  getPageInfoForAnalytics(): void {
    const prefUI = this.cookieService.getCookieValue('prefUI') || '';
    this.analyticsData = getPageInfoDataForAnalytics(
      this.analyticsData,
      prefUI,
      this.pageLoadStart
    );
  }

  setDataForAnalyticsOnLoad(): void {
    this.getPageInfoForAnalytics();
    this.setUserDataForAnalytics();
    this.setAdobeAnalytics(this.analyticsData);
  }
}
